/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGetStationConfigQueryResponse, ContentAiGetStationConfigPathParams, ContentAiGetStationConfig401, ContentAiGetStationConfig403 } from "../models/ContentAiGetStationConfig";

export function getContentAiGetStationConfigUrl(stationId: ContentAiGetStationConfigPathParams["stationId"]) {
  const res = { method: 'GET', url: `/content-ai/v1/station-config/${stationId}` as const }
  return res
}

/**
 * @summary Get station config for client user
 * {@link /content-ai/v1/station-config/:stationId}
 */
export async function contentAiGetStationConfig(stationId: ContentAiGetStationConfigPathParams["stationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ContentAiGetStationConfigQueryResponse, ResponseErrorConfig<ContentAiGetStationConfig401 | ContentAiGetStationConfig403>, unknown>({ method : "GET", url : getContentAiGetStationConfigUrl(stationId).url.toString(), ... requestConfig })
  return res.data
}